import { FC, useContext } from 'react';

import { CURRENCIES } from '@savgroup-front-common/constants';
import { TransportPlan } from '@savgroup-front-common/core/api/Claim/getClaimGroupTransportPlanQuery';
import { Img } from '@savgroup-front-common/core/atoms/Img';
import {
  safeFormattedIntlString,
  SafeFormattedMessageWithoutSpread,
} from '@savgroup-front-common/core/formatters';
import { formatAmountWithCurrency } from '@savgroup-front-common/core/formatters/intl';

import { InitContext } from '@/view/app/NewLayout/InitProvider/InitProvider.context';

import {
  $ItemContentTextWrapper,
  $ItemContentWrapper,
  $ItemDescription,
  $ItemLogo,
  $ItemPrice,
  $ItemTitle,
  $RadioCardBody,
  $RadioCardContainer,
  $RadioCardFirstLine,
  $RadioCardLabelContainer,
} from '../ChoosePickupPointCard/ChoosePickupPointCard.styles';
import { getUrlLogoCarrier } from '../PickupPointList.helpers';

import messages from './messages';

interface RelayPointCarrierCardProps {
  transportPlan: TransportPlan;
  isSelected: boolean;
  onSelect: (transportPlan: TransportPlan) => void;
}

export const RelayPointCarrierCard: FC<RelayPointCarrierCardProps> = ({
  transportPlan,
  isSelected,
  onSelect,
}) => {
  const { orders } = useContext(InitContext);
  const sellerId = orders?.at(0)?.sellerId;

  return (
    <$RadioCardLabelContainer
      data-testid={`relay-point-carrier-card-${transportPlan.transportPlanId}`}
      onClick={() => onSelect(transportPlan)}
      $isSelected={isSelected}
    >
      <$RadioCardContainer>
        <$RadioCardFirstLine>
          <$RadioCardBody hasImage={false}>
            <$ItemContentWrapper>
              <$ItemContentTextWrapper>
                <$ItemTitle $isSelected={isSelected}>
                  {transportPlan.carrier}
                </$ItemTitle>
                <$ItemDescription>
                  <SafeFormattedMessageWithoutSpread
                    message={messages.relayPointWithoutSelectionDidactics}
                  />
                </$ItemDescription>
                {!!transportPlan.priceWithTax && (
                  <$ItemPrice $hasPrice $hasPickupPointType={false}>
                    {`${formatAmountWithCurrency(
                      transportPlan.priceWithTax,
                      CURRENCIES.EUR,
                    )?.toString()} ${
                      transportPlan.isDeductible
                        ? safeFormattedIntlString(messages.deductibleFromRefund)
                        : ''
                    }`}
                  </$ItemPrice>
                )}
              </$ItemContentTextWrapper>
              <$ItemLogo>
                <Img
                  alt={transportPlan.carrier}
                  urls={getUrlLogoCarrier({ sellerId, transportPlan })}
                />
              </$ItemLogo>
            </$ItemContentWrapper>
          </$RadioCardBody>
        </$RadioCardFirstLine>
      </$RadioCardContainer>
    </$RadioCardLabelContainer>
  );
};
